import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {getSuppliers} from "../Supplier/actions";
import {Button, Card, Form, Input, notification, Select} from 'antd';

import {getBulkProduct, updateBulkProduct} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {bindActionCreators} from "redux";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;
const Option = Select.Option;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateBulkProductForm extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    /* actions */
    updateBulkProduct: PropTypes.func.isRequired,
    getSuppliers: PropTypes.func.isRequired,
    getBulkProduct: PropTypes.func.isRequired,
    /* state */
    loading: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
    dispensaryId: PropTypes.string.isRequired,
    suppliers: PropTypes.array.isRequired,
    bulkProduct: PropTypes.object.isRequired,
  };
  
  state = {};

  componentDidMount() {
    this._load();
    this._loadBulkProduct();
  }

  componentDidUpdate(prevProps) {
    if (this.props.dispensaryId !== prevProps.dispensaryId) this._load();
    if (this.props.match.params.bulkProductId !== prevProps.match.params.bulkProductId) this._loadBulkProduct();
  }

  _load() {
    const {dispensaryId} = this.props;
    this.props.getSuppliers({dispensaryId});
  }

  _loadBulkProduct() {
    const {bulkProductId} = decodeParams(this.props.match.params);
    this.props.getBulkProduct({bulkProductId});
  }
  
  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {dispensaryId} = this.props;
    const {bulkProductId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.updateBulkProduct({...values, dispensaryId, bulkProductId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, suppliers, bulkProduct} = this.props;
    const {name, description, supplierId} = bulkProduct;
    return (
      <Card title="Update Bulk Product">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Supplier"
          >
            {getFieldDecorator('supplierId', {
              initialValue: supplierId
            })(
              <Select>
                <Option key="updateBulkProduct-supplierId-null" value={null}>NONE</Option>
                {suppliers.map(({supplierId, name}) => <Option key={supplierId} value={supplierId}>{name}</Option>)}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Description"
          >
            {getFieldDecorator('description', {
              initialValue: description
            })(
              <TextArea />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Unit Of Measure Class"
          >
            {bulkProduct.unitOfMeasureClass}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Bulk Product
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const UpdateBulkProductPage = Form.create()(UpdateBulkProductForm);

const mapStateToProps = state => ({
  loading: state.bulkProduct.updatingBulkProduct || state.supplier.gettingSuppliers || state.bulkProduct.bulkProductLoading,
  dispensaryId: state.dispensary.selectedDispensaryId,
  suppliers: state.supplier.suppliers,
  bulkProduct: state.bulkProduct.bulkProduct || {},
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  updateBulkProduct,
  getBulkProduct,
  getSuppliers,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(UpdateBulkProductPage);



// WEBPACK FOOTER //
// ./src/BulkProduct/UpdateBulkProductPage.js